import React from 'react';

import HistoryService from '../../services/history-service';

const _parent = Symbol('parent');
const _route = Symbol('route');

class RouteContext {

  static Context = React.createContext(new RouteContext('', null));

  [_parent]: RouteContext | null;
  [_route]: string;

  constructor(route: string = '', parent: RouteContext | null) {
    this[_parent] = parent;
    this[_route] = route;
  }

  get(): string {
    const parent = this[_parent];
    const parentRoute = parent ? parent.get() : '';
    const resolved =  parentRoute + this[_route];

    return HistoryService.makeURL(resolved);
  }

  nestedRoute(route: string): string {
    const parentRoute = this.get();
    return HistoryService.makeURL(parentRoute + route);
  }

  nestedContext(route: string): RouteContext {
    return new RouteContext(route, this);
  }

}

export default RouteContext;
